import React, { useState } from "react";
import { FileText, Download, X } from "lucide-react";
import { toast } from "react-toastify";

const normalizeDnList = (dnList) => {
  if (!Array.isArray(dnList) || dnList.length === 0) return [];
  return dnList.map((d) => {
    const filename = d.filename || d.FileName || "DN.pdf";
    return {
      id: d.deliveryNoteId ?? d.delivery_note_id ?? d.id,
      deliveryNoteId: d.deliveryNoteId ?? d.delivery_note_id ?? d.id,
      filename,
      label: filename.length > 14 ? filename.slice(0, 14) + "..." : filename,
    };
  });
};

const CreateSalesOrderModal = ({ isOpen, onClose, onProceed, dnList = [] }) => {
  const [selectedDNRef, setSelectedDNRef] = useState(null);

  if (!isOpen) return null;

  const modalDnList = normalizeDnList(dnList);

  const handleClose = () => {
    setSelectedDNRef(null);
    onClose?.();
  };

  const handleProceed = () => {
    if (!selectedDNRef) return;
    onProceed?.(selectedDNRef);
    setSelectedDNRef(null);
  };

  const handleDownload = async (e, item) => {
    e.stopPropagation();
    if (String(item.deliveryNoteId).startsWith("dummy")) return;
    try {
      toast.info("Downloading Delivery Note...");
    } catch {
      toast.error("Failed to download Delivery Note");
    }
  };

  return (
    <div
      className="dn-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
    >
      <div className="dn-modal-box">
        <div className="dn-modal-header">
          <h2 className="dn-modal-title">Create Sales Order</h2>
          <button className="dn-modal-close" onClick={handleClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <p className="dn-modal-subtitle">Choose Delivery Note Reference</p>

        <div className="dn-modal-po-list">
          {modalDnList.length === 0 && (
            <div style={{ padding: 16, color: "#6b7280", textAlign: "center" }}>
              No Delivery Notes available
            </div>
          )}
          {modalDnList.map((item) => (
            <div
              key={item.id}
              className={`dn-modal-po-row${selectedDNRef?.id === item.id ? " dn-modal-po-row--selected" : ""}`}
              onClick={() => setSelectedDNRef(item)}
            >
              <FileText size={16} className="dn-modal-po-icon" />
              <span className="dn-modal-po-label">{item.label}</span>
              <span className="dn-modal-po-filename">{item.filename}</span>
              <button
                className="dn-modal-po-download"
                onClick={(e) => handleDownload(e, item)}
                title="Download"
                aria-label="Download Delivery Note"
              >
                <Download size={16} />
              </button>
            </div>
          ))}
        </div>

        <div className="dn-modal-footer">
          <button className="dn-modal-btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="dn-modal-btn-proceed"
            disabled={!selectedDNRef}
            onClick={handleProceed}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateSalesOrderModal;
